import { Close } from '@mui/icons-material';
import { Box, Button, Checkbox, IconButton, Typography } from '@mui/material';
import { TickCircle, Trash } from 'iconsax-react';
import type { FC } from 'react';

import { hasValue } from '@core/utils/equality';

type Props = {
  selectedCount: number;
  isAllSelected: boolean;
  onSelectAllChange: (isSelected: boolean) => void;
  onMarkAsRead?: () => void;
  onDelete?: () => void;
  onClear: () => void;
};

export const NotificationsBulkActions: FC<Props> = ({
  selectedCount,
  isAllSelected,
  onSelectAllChange,
  onMarkAsRead,
  onDelete,
  onClear,
}) => (
  <Box
    display='flex'
    alignItems='center'
    justifyContent='space-between'
    gap={1}
    height={54}
    marginX={2}
    marginY={1.5}
    paddingX={1}
    borderRadius={1.5}
    bgcolor='SlabGray.Table'
    flexShrink={0}
  >
    <Box display='flex' alignItems='center' gap={0.5} minWidth={0}>
      <Checkbox
        color='primary'
        size='small'
        checked={isAllSelected}
        indeterminate={!isAllSelected}
        onChange={(event): void => onSelectAllChange(event.target.checked)}
        inputProps={{ 'aria-label': 'Select all notifications' }}
        sx={{ padding: 0.5 }}
      />
      <Typography variant='body2' fontWeight={500} noWrap>
        {`${selectedCount} selected`}
      </Typography>
    </Box>

    <Box display='flex' alignItems='center' gap={1.5}>
      {hasValue(onMarkAsRead) && (
        <Button
          variant='slab-action-bordered'
          startIcon={<TickCircle size={20} variant='TwoTone' />}
          onClick={onMarkAsRead}
        >
          Mark As Read
        </Button>
      )}
      {hasValue(onDelete) && (
        <Button
          variant='slab-action-bordered'
          startIcon={<Trash size={20} variant='TwoTone' />}
          onClick={onDelete}
        >
          Delete
        </Button>
      )}
      <IconButton
        size='small'
        aria-label='Clear selection'
        onClick={onClear}
        sx={{
          padding: '10px',
          backgroundColor: 'SlabGray.0',
          border: '1px solid',
          borderColor: 'SlabGray.Border',
          borderRadius: '8px',
          '&:hover': {
            backgroundColor: 'SlabGray.50',
          },
        }}
      >
        <Close sx={{ fontSize: 22, color: 'SlabIndigo.700' }} />
      </IconButton>
    </Box>
  </Box>
);
